import { Container, Row } from "react-bootstrap";
import { Autoplay, Pagination, Keyboard, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
const Introduction = () => {
  const SwiperSlideData = [
    {
      img: "/images/1_SliderImage_KERA.webp",
    },
    {
      img: "/images/intial image.webp",
    },
    {
      img: "/images/3_SliderImage_KERA.webp",
    },
    {
      img: "/images/20250702_151417-1.webp",
    },
    {
      img: "/images/5_SliderImage_KERA.webp",
    },
  ];
  return (
    <>
      <section className="overflow-hidden w-[100%] pt-[40px]">
        <div>
          <Swiper
            className="white-move swiper-pagination-light w-[80%] h-[450px] md:h-[550px] sm:h-[500px] sm:w-[100%] swiper-pagination-medium  relative swiper-navigation-04 swiper-navigation-dark travel-agency-slider"
            slidesPerView={1}
            loop={true}
            keyboard={true}
            navigation={true}
            modules={[Pagination, Autoplay, Keyboard, Navigation]}
            pagination={{ clickable: true }}
            autoplay={{ delay: 4500, disableOnInteraction: false }}
            breakpoints={{
              575: {
                pagination: true,
              },
            }}
          >
            {SwiperSlideData.map((item, i) => {
              return (
                <SwiperSlide key={i} className="relative">
                  {/* The image now serves as the base layer */}
                  <div className="relative h-[60vh] w-full">
                    <div className="relative h-full w-full">
                      <img
                        src={item.img}
                        alt=""
                        className="w-full h-full object-cover object-center"
                        style={{
                          // maxHeight: '715px',
                          width: "100%",
                        }}
                      />
                    </div>
                  </div>

                  {/* Gradient Overlay */}
                  {/* <div
                  className="absolute inset-0 w-full h-full"
                  style={{
                    background: 'linear-gradient(to right, rgba(0,0,0,0.7), rgba(0,0,0,0))',
                  }}
                ></div> */}

                  {/* Content Layer - ensure it's above both the image and the gradient */}
                  <Container className="relative z-[1]">
                    {" "}
                    {/* Added z-[1] for explicit stacking context */}
                    <Row className="items-center h-[100vh]  md:h-[650px] sm:h-[450px]">
                      {/* <Col lg={5} md={6} sm={8}>
                      <h1
                        className="font-serif text-[100px]  font-bold sm:text-[60px] text-[#025a81] uppercase mb-[40px] tracking-[-2px] sm:mb-[30px] xs:mb-[15px]"
                        style={{ textShadow: '1px 1px 2px white' }}
                      >
                        KERA
                      </h1>
                      <p className="text-[20px] sm:text-[15px] uppercase leading-[30px] text-[#8fc642] w-[90%] mb-12 lg:w-[90%]  sm:mb-[30px]  md:w-full xs:mb-[15px]">
                        Kerala Climate Resilient Agri Value Chain Modernization
                      </p>
                      <Buttons
                        type="submit"
                        className="bg-[transparent] sm:p-[10px 10px] sm:w-[200px] sm:text-[15px] hover:text-black tracking-[2px] font-medium font-serif rounded-none uppercase md:mb-[15px] btn-fancy"
                        themeColor="white"
                        color="white"
                        size="lg"
                        title="Get started now"
                      />
                    </Col> */}
                    </Row>
                  </Container>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </section>
    </>
  );
};

export default Introduction;
